import { PRODUCTS as PRODUCTS_FALLBACK } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { useSettings } from "@/contexts/SettingsContext";
import { useCollection } from "@/hooks/useCollection";

export const Products = () => {
  const { waLink } = useSettings();
  const { data: PRODUCTS } = useCollection("products", "/products", PRODUCTS_FALLBACK);
  return (
    <section id="produk" className="bg-cream py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <Overline>Koleksi Madu</Overline>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink">
                Pilih madu favorit keluarga.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-stone2 max-w-sm md:text-right">
              Setiap varian dipanen dari sumber nektar berbeda, menghadirkan rasa
              dan aroma yang unik.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <article
                data-testid={`product-${p.id}`}
                className="group flex h-full flex-col"
              >
                <div className="relative overflow-hidden rounded-[1.75rem] arch-top bg-cream-200">
                  <span className="absolute top-4 left-4 z-10 rounded-full bg-cream/90 backdrop-blur px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brandRed">
                    {p.tag}
                  </span>
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-[340px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col pt-6">
                  <div className="flex items-baseline justify-between gap-4">
                    <h3 className="font-display text-2xl md:text-3xl tracking-tight text-ink">
                      {p.name}
                    </h3>
                    <span className="text-xs text-stone2 whitespace-nowrap">{p.unit}</span>
                  </div>
                  <p className="mt-3 text-stone2 leading-relaxed text-[15px] flex-1">
                    {p.desc}
                  </p>
                  <div className="mt-6 flex items-center justify-end">
                    <a
                      data-testid={`product-order-${p.id}`}
                      href={waLink(`Halo Samsi Madu, saya mau pesan ${p.name} (${p.unit}).`)}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-cream hover:bg-honey hover:text-ink transition-colors duration-300"
                    >
                      Pesan
                      <span>→</span>
                    </a>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
